<template>
  <div class="container">
    <content-header :data="[{text:'试卷一览', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="关键词"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="test_paper_name"
            label="试卷名称"
            width="150"
            fixed>
          </el-table-column>
          <el-table-column
            prop="single_count"
            label="单选题数">
          </el-table-column>
          <el-table-column
            prop="single_score"
            label="单选题分值">
          </el-table-column>
          <el-table-column
            prop="multi_count"
            label="多选题数">
          </el-table-column>
          <el-table-column
            prop="multi_score"
            label="多选题分值">
          </el-table-column>
          <el-table-column
            prop="total_point"
            label="总分">
          </el-table-column>
          <el-table-column
            prop="cutoff"
            label="合格">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="150">
            <template slot-scope="scope">
              <el-button @click="initEditHandle(scope)" type="text" size="small" >修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" >删除</el-button>
              <el-button @click="initQuestionHandle(scope)" type="text" size="small" >试题管理</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 新建弹出区域 -->
      <div class="new-wrap">
        <el-dialog :title="curObj.test_paper_id ? '修改试卷' : '添加试卷'" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
            <el-form-item prop="test_paper_name" label="试卷名称" :label-width="formLabelWidth">
              <el-input name="test_paper_name" v-model="curObj.test_paper_name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="cover_url" label="封面图片" :label-width="formLabelWidth">
              <el-upload
                class="avatar-uploader"
                :headers = "uploadHeader"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="uploadPhotoSuccess"
                :before-upload="beforePhotoUpload"
                :on-error="uploadError">
                <img v-if="curObj.cover_url" :src="domainPic + curObj.cover_url" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>

            <el-form-item prop="single_score" label="单选题分值" :label-width="formLabelWidth">
              <el-input name="single_score" v-model="curObj.single_score" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="multi_score" label="多选题分值" :label-width="formLabelWidth">
              <el-input name="multi_score" v-model="curObj.multi_score" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="cutoff" label="通过分数线" :label-width="formLabelWidth">
              <el-input name="cutoff" v-model="curObj.cutoff" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item prop="description" label="试卷介绍" :label-width="formLabelWidth">
              <el-input type="textarea" name="description" v-model="curObj.description" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import sessionstorage from 'utils/sessionstorage'
  import urls from 'config/urls'
  import TestPaperModel from 'models/testPaper'

  export default {
    components: {
    },
    data () {
      return {
        domainPic: constants.basic.domain_pic,
        uploadUrl: constants.basic.domain + urls.file.upload,
        uploadHeader: {},
        keywords: '',
        tableData: [],
        isObjShow: false,
        curObj: {
          test_paper_id: '',
          test_paper_name: '',
          cover_url: '',
          single_score: '',
          multi_score: '',
          cutoff: '',
          description: ''
        },
        formLabelWidth: '120px',
        curObjRules: {
          test_paper_name: [{ required: true, message: '请输入试卷名称', trigger: 'blur' }],
          cover_url: [{ required: true, message: '请上传封面图片', trigger: 'blur' }],
          single_score: [{ required: true, message: '请输入单选题分值', trigger: 'blur' }],
          multi_score: [{ required: true, message: '请输入多选题分值', trigger: 'blur' }],
          cutoff: [{ required: true, message: '请输入分数线', trigger: 'blur' }],
          description: [{ required: true, message: '请输入试卷介绍', trigger: 'blur' }]
        },
        curPage: 1,
        pageSize: 10,
        total: 0
      }
    },
    created () {
      sessionstorage.getItem('token').then(token => {
        if (!token) return
        this.uploadHeader = {Authorization: 'Bearer ' + token}
      })
      //
      this.getObjList()
    },
    methods: {
      uploadError (err, file, fileList) {
        console.log(err)
      },
      uploadPhotoSuccess (response, file, fileList) {
        this.curObj.cover_url = response
      },
      beforePhotoUpload (file) {
        const isPic = (file.type === 'image/jpeg' || file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPic) {
          this.$message.error('上传图片只能是 JPG/PNG 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
        }
        return isPic && isLt2M
      },
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          keywords: this.keywords
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        console.log(_opts)
        //
        TestPaperModel.find(_opts).then(res => {
          this.tableData = res.item_list
          this.total = res.total
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            TestPaperModel.delete({
              id: item.row.test_paper_id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.test_paper_id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = {
          test_paper_id: '',
          test_paper_name: '',
          cover_url: '',
          single_score: '',
          multi_score: '',
          cutoff: '',
          description: ''
        }
        this.isObjShow = true
      },
      newHandle () {
        TestPaperModel.create(this.curObj).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.curObj = {
          test_paper_id: item.row.test_paper_id,
          test_paper_name: item.row.test_paper_name,
          cover_url: item.row.cover_url,
          single_score: item.row.single_score,
          multi_score: item.row.multi_score,
          cutoff: item.row.cutoff,
          description: item.row.description
        }
        this.isObjShow = true
      },
      editHandle () {
        TestPaperModel.update(this.curObj).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      searchHandle () {
        this.curPage = 1
        this.getObjList()
      },
      initQuestionHandle (item) {
        this.$router.push({
          name: 'testPaper.question',
          query: { id: item.row.test_paper_id, name: item.row.test_paper_name }
        })
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
    .avatar-uploader
        border: 1px dashed #d9d9d9
        border-radius: 6px
        cursor: pointer
        position: relative
        overflow: hidden
        width: 180px
        &:hover
          border-color: #409EFF
        .avatar-uploader-icon
          font-size: 28px
          color: #8c939d
          width: 178px
          height: 178px
          line-height: 178px
          text-align: center
        .avatar
          width: 178px
          height: 178px
          display: block

</style>



// WEBPACK FOOTER //
// src/views/TestPaper.vue